// extracted by mini-css-extract-plugin
module.exports = {"article":"team-member_article__Ftq26","headshot":"team-member_headshot__D4lNm","memberName":"team-member_memberName__EwCW6","bioCta":"team-member_bioCta__7DKaY"};